<template>
    <el-popover placement="top-start" width="350" trigger="click">
        <div v-if="about === 'Дата продажи автомобиля'" style="word-break: normal">Дата в ДКП</div>
        <div v-if="about === 'Стоимость автомобиля'" style="word-break: normal">Полная стоимость (все расходы + удорожание)</div>
        <div v-if="about === 'Приход автомобиля'" style="word-break: normal">Сумма в приходной накладной</div>
        <div v-if="about === 'Прибыль по сделке'" style="word-break: normal">Прибыль = Сумма продажи - Накопленная стоимость</div>
        <div v-if="about === 'Список исходящих номеров'" style="word-break: normal">В списке телефонов присутствуют только те телефоны которые подключены у провайдера и в ЦРМ этот телефон прописан в активном источнике</div>
        <div v-if="about === 'Правила имени пользовательской переменной'" style="word-break: normal">латинские буквы, точка, подчеркивание</div>
        <div v-if="about === 'Накопленная стоимость автомобиля'" style="word-break: normal">
            <div class="mb-2">Сумма приходной стоимости машины и всех расходов на неё</div>
            <ul class="list-unstyled mb-2">
                <li>Формула расчета:</li>
                <li>+ сумма в приходной накладной</li>
                <li>+ расходы по кассе</li>
                <li>+ расходы по банку</li>
                <li>+ виртуальные расходы</li>
            </ul>
            <div class="small py-1"><i class="fas fa-exclamation text-warning pr-2"></i>Рассчитывается на основе операций текущей площадки</div>
<!--            <div class="small py-1"><i class="fas fa-exclamation text-warning pr-2"></i>Не рассчитывается при отсутствии приходной накладной</div>-->
<!--            <div class="small py-1"><i class="fas fa-exclamation text-warning pr-2"></i>Расходы суммируются только те которые были совершены после создания приходной накладной, т.е. все расходы по машине которые были внесены ДО даты в приходной накладной, учитываться не будут.</div>-->
        </div>
        <span class="text-gray cursor-pointer" slot="reference"><i class="fas fa-question-circle" style="font-size: 80%;position: relative;top: -4px;"></i></span>
        <div v-if="about === 'Смена автомобиля в сделке'" style="word-break: normal">После создания сделки, автомобиль может сменить только РКО/РОП. Чтобы сменить, необходимо перевести сделку в статус "Открыто"</div>
        <div v-if="about === 'Смена статуса в сделке'" style="word-break: normal">Нельзя из статуса "Закрыто" сразу сменить статус на "Отменена", так же как и со статуса "Отменена" в статус "Закрыта". Чтобы это сделать, вам необходимо сначала сохранить сделку в статусе "Открыта", а далее сменить статус на нужный.</div>
        <div v-if="about === 'Скидки в сделке'" style="word-break: normal">Для отображения в документах</div>
        <div v-if="about === 'Количество символов в смс'" style="word-break: normal">
            <table class="table table-bordered table-sm">
                <thead style="text-align: center;vertical-align: middle;">
                <tr>
                    <td rowspan="2">Длина SMS, частей</td>
                    <td colspan="2" rowspan="1">Количество символов в SMS-сообщении, шт</td>
                </tr>
                <tr>
                    <td>Латиница</td>
                    <td>Кириллица</td>
                </tr>
                </thead>
                <tbody>
                <tr><td>1</td><td>160</td><td>70</td></tr>
                <tr><td>2</td><td>{{153 * 2}}</td><td>{{67 * 2}}</td></tr>
                <tr><td>3</td><td>{{153 * 3}}</td><td>{{67 * 3}}</td></tr>
                <tr><td>4</td><td>{{153 * 4}}</td><td>{{67 * 4}}</td></tr>
                <tr><td>5</td><td>{{153 * 5}}</td><td>{{67 * 5}}</td></tr>
                <tr><td>6</td><td>{{153 * 6}}</td><td>{{67 * 6}}</td></tr>
                <tr><td>7</td><td>{{153 * 7}}</td><td>{{67 * 7}}</td></tr>
                <tr><td>8</td><td>{{153 * 8}}</td><td>{{67 * 8}}</td></tr>
                </tbody>
            </table>
        </div>
        <div v-if="about === 'Инструкция по ЧС номеров'" style="word-break: normal">Каждый номер с новой строки, формат любой, невалидные номера не добавляются.</div>
    </el-popover>
</template>

<script>
export default {
    name: "HelpPopover",
    props: {
        about: {
            type: String,
            required: true,
        }
    },
}
</script>

<style scoped>

</style>
